import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import UidDashboardDetailsComponent from "./component";

const UidDashboardDetailsContainer = (props) => {
  const navigate = useNavigate();
  const { uid } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uidDetails, setUidDetails] = useState(null);
  const [vmList, setVmList] = useState([]);
  const [selectedVmDetails, setSelectedVmDetails] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [mapSuccess, setMapSuccess] = useState(false);
  const [unmapSuccess, setUnmapSuccess] = useState(false);
  const [mapConfirmationOpen, setMapConfirmationOpen] = useState(false);
  const [pendingMapData, setPendingMapData] = useState(null);

  const getCurrentMode = () => {
    if (location.pathname.includes('/uid-unmap/')) {
      return 'unmap';
    } else if (location.pathname.includes('/uid-map/')) {
      return 'map';
    } else {
      return 'details';
    }
  };

  const currentMode = getCurrentMode();

  useEffect(() => {
    if (uid) {
      loadUidDetails(uid);
      handleGetVmList(""); // Load initial VM list without search
    }
  }, [uid]);

  // Function to load UID details
  const loadUidDetails = (uid) => {
    setLoading(true);
    setError(null);
   
    props.getDataFromAPI(
      `/partner/api/uid/${uid}/details`,
      "GET",
      undefined,
      (response) => {
        console.log("UID Details API Response:", response);
        setUidDetails(response);
        setLoading(false);
      },
      (error) => {
        console.error("UID Details API Error:", error);
        const errorMessage = error?.message || "Failed to fetch UID details";
        setError(errorMessage);
        toastr.error("Error", errorMessage);
        setLoading(false);
      }
    );
  };

  // Function to fetch VM details by ID
  const fetchVmDetails = (id) => {
    setSearchLoading(true);
    
    props.getDataFromAPI(
      `/partner/api/v2/machine/${id}`,
      "GET",
      undefined,
      (response) => {
        console.log("VM Details API Response:", response);
        setSelectedVmDetails(response || response);
        setSearchLoading(false);
      },
      (error) => {
        console.error("VM Details API Error:", error);
        const errorMessage = error?.message || "Failed to fetch VM details";
        toastr.error("Error", errorMessage);
        setSearchLoading(false);
      }
    );
  };

  // Handle VM selection
  const handleVmSelect = (vmId) => {
    if (vmId) {
      fetchVmDetails(vmId);
    } else {
      setSelectedVmDetails(null);
    }
  };

  // Get VM List function with search - UPDATED
  const handleGetVmList = async (searchQuery = "") => {
    setSearchLoading(true);
    
    // Use the correct API endpoint for searching VMs (machines)
    const apiUrl = searchQuery 
      ? `/partner/api/v2/machine/unmapped?search=${encodeURIComponent(searchQuery)}`
      : `/partner/api/v2/machine/unmapped`;

    console.log("Fetching VM list from:", apiUrl);

    props.getDataFromAPI(
      apiUrl,
      "GET",
      undefined,
      (response) => {
        console.log("VM List API Response:", response);
        // Handle the response format - it might be an array or an object with data property
        if (Array.isArray(response)) {
          setVmList(response);
        } else if (response && response) {
          setVmList(response.data);
        } else if (response && response.machines) {
          setVmList(response.machines);
        } else {
          setVmList([]);
          console.warn("Unexpected VM list response format:", response);
        }
        setSearchLoading(false);
      },
      (err) => {
        const errorMessage = err?.message || "Unable to fetch VM list";
        console.error("Unable to fetch VM list:", errorMessage);
        toastr.error("Error", errorMessage);
        setVmList([]); // Set empty array on error
        setSearchLoading(false);
      }
    );
  };

  // Handle search - UPDATED with debouncing
  const handleSearch = (query) => {
    setSearchQuery(query);
    // Add a small debounce to prevent too many API calls
    const timeoutId = setTimeout(() => {
      handleGetVmList(query);
    }, 300);
    
    // Cleanup timeout on subsequent calls
    return () => clearTimeout(timeoutId);
  };

  // Handle unmap action
  const handleUnmap = (reason) => {
    if (!uidDetails) return;
    
    setLoading(true);
    setError(null);
    
    const unmapPayload = {
      uids: [uid],
      vmId: uidDetails.vmInfo?.id || 0,
      reason: reason
    };

    console.log("Unmap Payload:", unmapPayload);

    return new Promise((resolve, reject) => {
      props.getDataFromAPI(
        `/partner/api/v2/uid-vm/unmap`,
        "POST",
        unmapPayload,
        (response) => {
          console.log("Unmap API Response:", response);
          setLoading(false);
            setUnmapSuccess(true); // Set success state
            toastr.success("Success", "UID unmapped successfully");
            resolve(response);
        
        },
        (error) => {
          console.error("Unmap API Network Error:", error);
          const errorMessage = error?.message || "Network error occurred";
          setError(errorMessage);
          toastr.error("Error", errorMessage);
          setLoading(false);
          reject(new Error(errorMessage));
        }
      );
    });
  };

 
  const handleMap = (vmid, reason) => {
    if (!uidDetails) return;
    
   
    setPendingMapData({ vmid, reason });
    
    setMapConfirmationOpen(true);
  };

  
  const handleConfirmedMap = async () => {
    if (!pendingMapData || !uidDetails) return;
    
    setLoading(true);
    setError(null);
    setMapConfirmationOpen(false);
    
    const { vmid, reason } = pendingMapData;
    
    const mapPayload = {
      uids: [uid],
      vmIds: [vmid],
    };

    return new Promise((resolve, reject) => {
      props.getDataFromAPI(
        `/partner/api/v2/uid-vm/map`,
        "POST",
        mapPayload,
        (response) => {
          console.log("Map API Response:", response);
           setLoading(false);
            setMapSuccess(true);
            toastr.success("Success", "UID mapped successfully");
            resolve(response);
         
        
        },
        (err) => {
          console.error("Map API Network Error:", err);
          const errorMessage = err?.message || "Network error occurred";
          setError(errorMessage);
          toastr.error("Error", errorMessage);
          setLoading(false);
          reject(new Error(errorMessage));
        }
      );
    });
  };


  const handleCancelMap = () => {
    setMapConfirmationOpen(false);
    setPendingMapData(null);
  };

  const handleUidTimeline = () => {
    navigate(`/home/configuration/uid-dashboard/uid-timeline/${uid}`)
  };


  const handleSuccessNavigation = () => {
    setMapSuccess(false);
    setUnmapSuccess(false);
    navigate(-1); 
  };


  const resetSuccessStates = () => {
    setMapSuccess(false);
    setUnmapSuccess(false);
  };

  return (
    <UidDashboardDetailsComponent
      uidDetails={uidDetails}
      loading={loading}
      error={error}
      navigate={navigate}
      onUnmap={handleUnmap}
      onMap={handleMap}
      onConfirmedMap={handleConfirmedMap}
      onCancelMap={handleCancelMap}
      currentMode={currentMode}
      handleUidTimeline={handleUidTimeline}
      vmList={vmList}
      selectedVmDetails={selectedVmDetails}
      onVmSelect={handleVmSelect}
      onSearch={handleSearch}
      searchQuery={searchQuery}
      searchLoading={searchLoading}
      onSuccessNavigation={handleSuccessNavigation}
      mapSuccess={mapSuccess}
      unmapSuccess={unmapSuccess}
      resetSuccessStates={resetSuccessStates}
      mapConfirmationOpen={mapConfirmationOpen}
      pendingMapData={pendingMapData}
    />
  );
};

export default connect(null, {
  getDataFromAPI,
})(UidDashboardDetailsContainer);